<template>
  <HpsfirProDrawer
    v-model:open="visible"
    title="模板草稿"
    width="80vw"
    max-width="1200px"
    content-class="business-table-drawer"
    body-class="business-table-drawer__body"
  >
    <HpsfirProTable
      v-if="visible"
      ref="tableRef"
      export-file-name="模板草稿"
      :columns="columns"
      :get-data="getData"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
    <HpsfirProForm :is-dialog="true" ref="addFormRef" title="添加到模板库" :items="items" @ok="handleOk"/>
  </HpsfirProDrawer>
</template>
<script lang="ts" setup>
import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const addFormRef = ref<any>();

const visible = ref(false);
const addInitValue = {

};
const conditionsInitValue = {
};

const currentDraftId = ref<number>();

const items: HpsfirProFormItem[] = [
  {
    name: 'templateType',
    label: '模板类型',
    type: 'select',
    rule: [{ required: true }],
    options: [
      {
        label: '普通模板',
        value: 0,
      },
      {
        label: '标准模板',
        value: 1,
      },
    ],
  },
];


const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'draftId',
      label: '草稿ID',
      type: 'number',
    },
    {
      name: 'currentVersion',
      label: '版本',
      type: 'string',
    },
    {
      name: 'description',
      label: '描述',
      type: 'string',
    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      width: 80,
      hideCreate: true,
      hideEdit: true,
      render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : ''),
    },

  ]);
});


const operates: any[] = [
  {
    key: 'addTpl',
    name: '添加到模板库',
    handler: useBaseAsync((row: any) => {
      // tpldraftRef.value?.show();
      currentDraftId.value = row.draftId;
      addFormRef.value?.reset();
      addFormRef.value?.showDialog();
    }),
  },
];

const loading = ref(false);


const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().weappTplApi.getTplDraftListweappTpl();
    const tableData: HpsfirProTableData = {
      total: res.data.data?.length || 0,
      data: res.data.data || [],
    };

    return tableData;
  } finally {
    loading.value = false;
  }
});

const handleOk = useBaseAsync(async(data: any) => {
  data.draftId = currentDraftId.value;
  await useApi().weappTplApi.addTplweappTpl(data);
  ElMessage.success('添加成功');
  visible.value = false;
});


const formatDeleteInfo = (row: any) => `您正在进行删除(${row.name})操作，请谨慎操作`;


init();
defineExpose({
  show: () => {
    tableRef.value?.refresh();
    visible.value = true;
  },
});

</script>
<style lang="scss" scoped>
</style>
